import { useState, useEffect } from 'react';
import debounce from 'lodash-es/debounce';

var getVisibility = function getVisibility(element) {
  return Boolean(element && (element.offsetWidth || element.offsetHeight || element.getClientRects().length));
};

var useBoundingClientRectListener = function useBoundingClientRectListener(ref) {
  var _React$useState = useState(undefined),
      dimensions = _React$useState[0],
      setDimensions = _React$useState[1];

  var isRefElementVisible = getVisibility(ref.current);

  var _React$useState2 = useState(isRefElementVisible),
      visibility = _React$useState2[0],
      setVisibility = _React$useState2[1];

  var resize = function resize() {
    if (visibility) {
      var _ref$current;

      setDimensions((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getBoundingClientRect());
    }
  };

  useEffect(function () {
    var timeout = setTimeout(resize, 0);
    var debouncedResize = debounce(resize, 250);
    window.addEventListener('resize', debouncedResize);
    return function () {
      clearTimeout(timeout);
      window.removeEventListener('resize', debouncedResize);
    };
  }, [ref.current, visibility]);
  useEffect(function () {
    var newRefElementVisibility = getVisibility(ref.current);

    if (visibility !== newRefElementVisibility) {
      // When visibility of an element changes, then the new visibility of the element can only be checked after the
      // component has rendered. That's why the visibility check is inside the useEffect. This useEffect will cause
      // the consumer to rerender and that will cause the above hook to recalculate the dimensions
      setVisibility(newRefElementVisibility);
    }
  });
  return dimensions;
};

export { useBoundingClientRectListener };
//# sourceMappingURL=useBoundingClientRectListener.js.map
